import React from 'react'
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { CircularProgress } from '@mui/material';
import { useAddwhiteip } from '../api/whiteipapi';
import PropTypes from 'prop-types';

const Ip_regex = /^(?!0)(?!.*\.$)((1?\d?\d|25[0-5]|2[0-4]\d)(\.|$)){4}$/;

const schema = yup.object().shape({
    ip: yup
        .string()
        .required("Enter IP Address")
        .matches(Ip_regex, "Enter a valid ip address"),
});

function AddWhiteIp({ toggle }) {
    const { control, handleSubmit, formState: { errors }, reset } = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            ip: '',
        }
    })

    const addWhiteIp = useAddwhiteip();
    const onSubmit = async (data) => {
        let res = await addWhiteIp.mutateAsync({ "ip": data.ip, "action": "whitelist" })
        if (res?.status) {
            reset()
            toggle();
        }
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className='mb-3'>
                <h6 className="pb-2">Add IP</h6>
                <Controller
                    control={control}
                    name="ip"
                    render={({ field }) => (
                        <input
                            {...field}
                            placeholder="Enter IP"
                            className={errors.ip ? 'form-control is-invalid' : 'form-control'}                             
                        />
                    )}
                />
                {errors.ip?.message && <p className='m-0 errMsg'>{errors.ip?.message}</p>}
            </div>
            <div className='d-flex justify-content-center rounded-pill'>
                <button className='btn btn-primary d-flex align-items-center' disabled={addWhiteIp.isLoading}>
                    {addWhiteIp.isLoading ?
                        <CircularProgress size={20} style={{ color: "#fff" }} className='mx-4' />
                        :
                        "Submit"}
                </button>
            </div>
        </form>
    )
}

AddWhiteIp.propTypes = {
    toggle: PropTypes.any.isRequired,
};

export default AddWhiteIp